
import React, { useEffect, useState } from 'react';
import { Orb } from '../types';

interface OrbProps {
  orb: Orb;
  onPop: (id: string) => void;
}

const OrbEntity: React.FC<OrbProps> = ({ orb, onPop }) => {
  const [timeLeft, setTimeLeft] = useState(1);

  useEffect(() => {
    const start = orb.createdAt;
    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      const progress = 1 - elapsed / orb.lifeSpan;
      if (progress <= 0) {
        clearInterval(interval);
      } else {
        setTimeLeft(progress);
      }
    }, 16);
    return () => clearInterval(interval);
  }, [orb]);

  const renderIcon = () => {
    switch (orb.type) {
      case 'ball': return <span className="text-2xl">⚽</span>;
      case 'shoot': return <span className="text-3xl animate-pulse">🚀</span>;
      case 'sub': return <span className="text-2xl">🔄</span>;
      case 'yellow': return <div className="w-6 h-8 bg-yellow-400 rounded-sm shadow-lg border border-white/20" />;
      case 'red': return <div className="w-6 h-8 bg-red-600 rounded-sm shadow-lg border border-white/20" />;
      case 'offside': return <span className="text-2xl">🚩</span>;
      case 'tackle': return <span className="text-2xl">⚔️</span>;
      default: return null;
    }
  };

  const style: React.CSSProperties = {
    left: `${orb.x}%`,
    top: `${orb.y}%`,
    width: `${orb.radius * 2}px`,
    height: `${orb.radius * 2}px`,
    boxShadow: orb.type === 'shoot' ? `0 0 30px ${orb.color}` : `0 0 15px ${orb.color}44`,
    opacity: timeLeft,
    transform: `scale(${0.3 + timeLeft * 0.7}) translate(-50%, -50%)`,
    transition: 'transform 0.05s linear',
    backgroundColor: (orb.type === 'yellow' || orb.type === 'red') ? 'transparent' : `${orb.color}22`,
  };

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onPop(orb.id);
      }}
      className={`absolute rounded-full cursor-pointer flex items-center justify-center border-2 border-white/20 z-20 backdrop-blur-sm transition-all md:hover:scale-110 active:scale-90`}
      style={style}
    >
      {renderIcon()}
      {/* Outer spinning ring for visual polish */}
      <div className={`absolute inset-0 rounded-full border-t-2 border-white/40 animate-spin`} style={{ animationDuration: '3s' }} />
    </div>
  );
};

export default OrbEntity;
